<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router/composables'
import { useUserStore } from '@/stores'
import { useCoinDisplayHold } from '@/pages/welfare/composables/useCoinDisplayHold'

const router = useRouter()
const userStore = useUserStore()
const { held } = useCoinDisplayHold()

// 显示值：未冻结时跟随 store；冻结期间保持不变，解除后立即同步
const displayBalance = ref(userStore.coinBalance)
watch(
  [() => userStore.coinBalance, held],
  ([balance, isHeld]) => {
    if (!isHeld)
      displayBalance.value = balance
  },
  { immediate: true },
)

function goToRecharge() {
  router.push({ name: 'pay' })
}
</script>

<template>
  <div class="coin-entry flex items-center cursor-pointer shrink-0" @click="goToRecharge">
    <!-- 半透明胶囊：钻石 + 余额 + 渐变加号 -->
    <div class="coin-pill flex items-center">
      <img
        src="/images/vowpath/home/icon-diamond.png"
        class="coin-gem shrink-0"
        data-coin-target
        alt=""
      >
      <span class="coin-balance">{{ displayBalance }}</span>
      <img
        src="/images/vowpath/home/icon-plus.png"
        class="coin-plus shrink-0"
        alt=""
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.coin-pill {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  height: 25px;
  padding: 0 6px;
}

.coin-gem {
  width: 20px;
  height: 18px;
  margin-right: 6px;
}

.coin-balance {
  color: rgba(255, 255, 255, 1);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 16px;
  margin-right: 6px;
}

.coin-plus {
  width: 16px;
  height: 16px;
}
</style>
